import {cs} from './cs';
import {en} from './en';
import {getLocalization} from '@happy-windows/framework/translate';

export const translation = getLocalization<typeof en>(en);
export const localizations = [
  {language: "cs", value: cs},
  {language: "en", value: en}
];
